import _ from 'lodash';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingStorageCarsFilled': false,
  'loadingLines': false,
  'savingLines': false,
  'timerStarted': false,
  'stoppingTimer': false,
  'listStorageCarsFilled': [],
  'storageSession': {},
  'storageCarSelected': '',
  'pendingLinesList': [],
};

function addStorageCar(currentStorageCars, newStorageCars, storageSession) {
  let newListStorageCars = [...currentStorageCars];
  newListStorageCars = _.concat(newListStorageCars, newStorageCars);

  if (storageSession.hasOpenSession) {
    newListStorageCars.push(storageSession.storageCar);
  }
  return newListStorageCars;
}

function removeStorageCars(listStorageCars, {storageCar, action}) {
  const newListStorageCars = [...listStorageCars];
  const index = newListStorageCars.indexOf(storageCar);
  if (index !== -1) {
    newListStorageCars.splice(index, 1);
  }
  return newListStorageCars;
}

export const storage = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.EMPTY_INFO]: (state, action) => ({
      ...state,
      'storageSession': {},
      'storageCarSelected': '',
      'listStorageCarsFilled': [],
      'pendingLinesList': [],
      'savingLines': false,
      'timerStarted': false,
    }),
    [ActionTypes.FETCHING_STORAGE_CARS]: (state, action) => ({
      ...state,
      'loadingStorageCarsFilled': true,
    }),
    [ActionTypes.FETCHED_STORAGE_CARS]: (state, action) => ({
      ...state,
      'loadingStorageCarsFilled': false,
      'listStorageCarsFilled': addStorageCar(
        state.listStorageCarsFilled,
        action.response.data,
        {}
      ),
    }),
    [ActionTypes.FETCHED_STORAGE_CARS_FAILED]: (state, action) => ({
      ...state,
      'loadingStorageCarsFilled': false,
      'listStorageCarsFilled': [],
    }),
    [ActionTypes.CHECKED_USER_STORAGE_SESSION]: (state, action) => ({
      ...state,
      'storageSession': action.response.data,
      'savingLines': action.response.data.hasOpenSession,
      'timerStarted': action.response.data.hasOpenSession,
      'listStorageCarsFilled': addStorageCar(
        state.listStorageCarsFilled,
        [],
        action.response.data
      ),
      'storageCarSelected': action.response.data.hasOpenSession ?
        action.response.data.storageCar :
        '',
    }),
    [ActionTypes.CHECKED_USER_STORAGE_SESSION_FAILED]: (state, action) => ({
      ...state,
      'storageSession': {},
    }),
    [ActionTypes.FETCHING_PENDING_LINES_TO_STORAGE_BY_CAR]: (
      state,
      action
    ) => ({
      ...state,
      'loadingLines': true,
    }),
    [ActionTypes.FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR]: (state, action) => ({
      ...state,
      'loadingLines': false,
      'pendingLinesList': action.response.data,
      'storageCarSelected': action.payload,
    }),
    [ActionTypes.FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingLines': false,
      'pendingLinesList': [],
    }),
    [ActionTypes.CHANGING_STORAGE_CAR_STATUS]: (state, action) => ({
      ...state,
      'stoppingTimer': true,
    }),
    [ActionTypes.CHANGED_STORAGE_CAR_STATUS]: (state, action) => {
      if (action.payload.action === 'startStorage') {
        return {
          ...state,
          'savingLines': true,
          'timerStarted': true,
          'storageSession': {
            'hasOpenSession': true,
            'elapsedTime': 0,
            'storageCar': action.payload.storageCar,
          },
          'storageCarSelected': action.payload.storageCar,
          'stoppingTimer': false,
        };
      }
      return {
        ...state,
        'savingLines': false,
        'timerStarted': false,
        'storageSession': {
          'hasOpenSession': false,
        },
        'listStorageCarsFilled': removeStorageCars(
          state.listStorageCarsFilled,
          action.payload
        ),
        'pendingLinesList': [],
        'storageCarSelected': '',
        'stoppingTimer': false,
      };
    },
    [ActionTypes.CHANGED_STORAGE_CAR_STATUS_FAILED]: (state, action) => ({
      ...state,
      'stoppingTimer': false,
    }),
  })(state, action);
};
